import React from 'react';

import { TaxIdentifierModal } from './tax-identifier-modal';
import { TaxFormContextProvider } from '../../context/tax-form-context-provider';
import { PageEventSourceStrings } from '../../hooks/use-track-event';

/**
 * @param {object} props
 * @param {() => void} props.onClose
 * @returns {JSX.Element}
 */
export const TaxIdentifierModalContainer = ({ onClose }) => (
  <TaxFormContextProvider source={PageEventSourceStrings.TAX_IDENTIFIER_MODAL}>
    <TaxIdentifierModal onClose={onClose} />
  </TaxFormContextProvider>
);
